/*
 * @Description: 路由配置文件
 * @Author: laoliu
 * @Date: 2021-01-17 22:43:52
 */
import Vue from 'vue'
import Router from 'vue-router'

import Login from '@/components/login/Login'
import PageFrame from '@/components/pageframe/PageFrame'
import AccountSettings from '@/components/personal/AccountSettings'
import NoticeCenter from '@/components/personal/NoticeCenter'

import InstAdminReg from '@/components/login/InstAdminReg'
import InstRegisterInfo from '@/components/login/InstRegisterInfo'

import Overview from '@/components/overview/Overview'

import InstitutionList from '@/components/instmng/InstitutionList'
import AttendantList from '@/components/instmng/AttendantList'
import CommentList from '@/components/instmng/CommentList'
import DutyRuleList from '@/components/instmng/DutyRuleList'

import MerchantList from '@/components/mchmng/MerchantList'
import MemberList from '@/components/memmng/MemberList'

import HospitalList from '@/components/hspmng/HospitalList'
import DepartmentList from '@/components/hspmng/DepartmentList'

import HserviceList from '@/components/hsvcmng/HserviceList'
import HsvcMatter from '@/components/hsvcmng/HsvcMatter'

import OrderList from '@/components/ordermng/OrderList'

import UserList from '@/components/usermng/UserList'
import AdminList from '@/components/usermng/AdminList'
import AgentList from '@/components/usermng/AgentList'

import InstReviewList from '@/components/review/InstReviewList'
import AttendantReviewList from '@/components/review/AttendantReviewList'
import MchReviewList from '@/components/review/MchReviewList'

import IncomeTaxList from '@/components/finance/IncomeTaxList'
import SharingList from '@/components/finance/SharingList'
import StatementList from '@/components/finance/StatementList'
import SettlementAcctList from '@/components/finance/SettlementAcctList'

import OrderReport from '@/components/report/OrderReport'
import IncomeReport from '@/components/report/IncomeReport'
import DutyReport from '@/components/report/DutyReport'

import HsvcCategoryCfg from '@/components/hsvccfg/HsvcCategoryCfg'
import HsvcCfg from '@/components/hsvccfg/HsvcCfg'
import HsvcMatterCfg from '@/components/hsvccfg/HsvcMatterCfg'

import AdvertCfg from '@/components/syscfg/AdvertCfgList'
import UserCfg from '@/components/syscfg/UserCfg'
import RoleCfg from '@/components/syscfg/RoleCfg'
import SysParam from '@/components/syscfg/SysParam'

import SysIndex from '@/components/sysmng/SysIndex'
import AccessStat from '@/components/sysmng/AccessStat'
import FileMng from '@/components/sysmng/FileMng'
import AppRelease from '@/components/sysmng/AppRelease'
import CacheMng from '@/components/sysmng/CacheMng'
import BizTrack from '@/components/sysmng/BizTrack'
import LogQuery from '@/components/sysmng/LogQuery'

// 解决"Navigating to current location (XXX) is not allowed"的问题
const routerPush = Router.prototype.push
Router.prototype.push = function push(location) {
        return routerPush.call(this, location).catch(error => error)
    }
    // 调用该组件的install方法
Vue.use(Router)

/**
 * @Author: laoliu,wanqian
 * @Date: 2021-01-17 22:43:52
 *   护工管理端登录，在url上需要区分不同的管理员。例如：
 *   医管登录： http://hgcloud1x-mng/hsp/xxxx
 *   机管登录： http://hgcloud1x-mng/inst/yyyy
 *   主管或超管：http://hgcloud1x-mng
 * 
 *   机构注册手机登录:http://xxx/hgcloud1x-mng/#/inst/_register
 */
export default new Router({
    routes: [{
            path: '/login/:adminType/:identifier',
            name: 'login',
            component: Login,
        },
        {
            path: '/inst/_register',
            name: 'instadminreg',
            component: InstAdminReg,
        },
        {
            path: '/inst/registerinfo',
            name: 'instregisterinfo',
            component: InstRegisterInfo,
        },
        {
            path: '/:adminType/:identifier',
            name: 'main',
            component: PageFrame,
            children: [
                // 个人中心
                {
                    path: '/personal/accountsettings',
                    name: 'accountsettings',
                    component: AccountSettings
                },
                // 消息中心
                {
                    path: '/personal/noticecenter',
                    name: 'noticecenter',
                    component: NoticeCenter
                },
                // 1-运营总览
                {
                    path: '/overview/overview',
                    name: 'overview', //正式运行时就去掉此注释
                    component: Overview
                },
                // 2-机构管理
                {
                    path: '/instmng/instlist',
                    name: 'instlist',
                    component: InstitutionList
                },
                {
                    path: '/instmng/atdnlist',
                    name: 'atdnlist',
                    component: AttendantList
                },
                {
                    path: '/instmng/commentlist',
                    name: 'commentlist',
                    component: CommentList
                },
                {
                    path: '/instmng/dutyrule',
                    component: DutyRuleList
                },
                {
                    path: '/instmng/mchlist',
                    name: 'mchlist',
                    component: MerchantList
                },
                {
                    path: '/instmng/lklmchlist',
                    name: 'memberlist',
                    component: MemberList
                },
                // 3-医院管理
                {
                    path: '/hspmng/hsplist',
                    name: 'hsplist',
                    component: HospitalList
                },
                {
                    path: '/hspmng/deptlist',
                    name: 'deptlist',
                    component: DepartmentList
                },
                // 4-服务管理
                {
                    path: '/hsvcmng/hsvclist',
                    name: 'hsvclist',
                    component: HserviceList
                },
                {
                    path: '/hsvcmng/hsvcmatter',
                    component: HsvcMatter
                },
                // 5-订单管理
                {
                    path: '/ordermng/orderlist',
                    name: 'orderlist',
                    component: OrderList
                },
                // 6-用户管理
                {
                    path: '/usermng/resident',
                    name: 'resident',
                    component: UserList
                },
                {
                    path: '/usermng/bkuser',
                    name: 'bkuser',
                    component: AdminList
                },
                {
                    path: '/usermng/agent',
                    name: 'agentlist',
                    component: AgentList
                },
                // 7-审核管理
                {
                    path: '/reviewmng/instreview',
                    component: InstReviewList
                },
                {
                    path: '/reviewmng/atdnreview',
                    component: AttendantReviewList
                },
				{
				    path: '/reviewmng/mchreview',
                    name: 'mchreview',
				    component: MchReviewList
				},
                // 8-财务管理
                {
                    path: '/finance/indvtax',
                    component: IncomeTaxList
                },
                {
                    path: '/finance/revenuesharing',
                    component: SharingList
                },
                {
                    path: '/finance/actstmt',
                    component: StatementList
                },
                {
                    path: '/finance/settlementacct',
                    component: SettlementAcctList
                },
                // {
                //     path: '/finance/wagessettlement',
                //     component: SalarySettlementList
                // },
                // 9-统计分析
                {
                    path: '/report/orderreport',
                    name: 'orderreport',
                    component: OrderReport
                },
                {
                    path: '/report/income',
                    component: IncomeReport
                },
                {
                    path: '/report/dutyrpt',
                    name: 'dutyrpt',
                    component: DutyReport
                },
                // 10-服务配置
                {
                    path: '/hsvccfg/typecfg',
                    component: HsvcCategoryCfg
                },
                {
                    path: '/hsvccfg/hsvccfg',
                    component: HsvcCfg
                },
                {
                    path: '/hsvccfg/mattercfg',
                    component: HsvcMatterCfg
                },
                // 11-系统配置
                {
                    path: '/syscfg/advertcfg',
                    component: AdvertCfg
                },
                {
                    path: '/syscfg/usercfg',
                    component: UserCfg
                },
                {
                    path: '/syscfg/rolecfg',
                    component: RoleCfg
                },
                {
                    path: '/syscfg/sysparam',
                    component: SysParam
                },
                // 12-系统管理
                {
                    path: '/sysmng/sysindex',
                    component: SysIndex
                },
                {
                    path: '/sysmng/accstat',
                    component: AccessStat
                },
                {
                    path: '/sysmng/filemng',
                    component: FileMng
                },
                {
                    path: '/sysmng/apprelease',
                    component: AppRelease
                },
                {
                    path: '/sysmng/cachemng',
                    component: CacheMng
                },
                {
                    path: '/sysmng/biztrack',
                    component: BizTrack
                },
                {
                    path: '/sysmng/logquery',
                    component: LogQuery
                }
            ]
        }
    ]
})


// WEBPACK FOOTER //
// ./src/router/index.js